<template>
  <div class="errors-section">
    <transition-group name="fadeInLeft">
      <div class="f-error" v-bind:key="error.field" v-for="error in errors" v-html="error.message">
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "FormulaErrors",
  props: {
    errors: {
      default: [],
      required: false,
    },
  },
};
</script>

<style scoped>
.errors-section {
  margin-right: auto;
}

.f-error {
  color: red;
  font-style: italic;
}

.fadeInLeft-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.fadeInLeft-enter-active {
  transition: all 300ms ease !important;
}

</style>
